import { render, staticRenderFns } from "./NewPackPage.vue?vue&type=template&id=0a918361&lang=pug&"
import script from "./NewPackPage.vue?vue&type=script&lang=js&"
export * from "./NewPackPage.vue?vue&type=script&lang=js&"
import style0 from "./NewPackPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports